export default __webpack_public_path__ + "static/media/sunday-club.2de89d23.png";